import { CredentialItem } from './credential-item'

export class SidelineCredentialItem extends CredentialItem {

  public constructor(data: any) {
    super(data)

    const { eligibility_status: value, completed_at, expires_at } = this.credential
    switch (value) {
      case 'incomplete': {
        this.setStatusTag({ color: 'yellow', value })
        break
      }
      case 'complete': {
        this.validityLabel = `Valid from ${this.getDate(completed_at)} - ${this.getDate(expires_at)}`
        this.setStatusTag({ value })
        break
      }
      case 'expired': {
        this.validityLabel = `Expired ${this.getDate(expires_at)}`
        this.setStatusTag({ color: 'red', value })
        break
      }
      default: this.defaultStatusTag()
    }
  }

}
